import { COLORS } from "@src/constants";
import { themeAlpine } from "ag-grid-community";

export const themeAlpineDefault = themeAlpine.withParams({
  fontFamily: "RWESansWeb-Regular, sans-serif",
  fontSize: 14,
  textColor: COLORS.FONT_00,

  headerFontFamily: "RWESansWeb-Medium, sans-serif",
  headerFontSize: 14,
  headerTextColor: COLORS.BRAND_100,
  headerBackgroundColor: COLORS.WHITE,

  cellHorizontalPadding: 18,

  foregroundColor: COLORS.BRAND_100,

  oddRowBackgroundColor: COLORS.SAND_20,
  rowHoverColor: COLORS.BRAND_10,
  selectedRowBackgroundColor: "none",
  checkboxCheckedBackgroundColor: COLORS.BRAND_100,
  valueChangeValueHighlightBackgroundColor: COLORS.GRADIENT_GREEN_30,
});
